import React from 'react';
import { MCButton } from 'src/components/basic';
import { remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

const NavigationButtons = ({ hide, loading, prev, next, labelNext = 'Next' }) => (
  <div className='mc-modal-footer' style={{ gap: remCss(20) }}>
    {!!prev && (
      <MCButton
        medium
        light
        radius
        primary
        disabled={loading}
        style={{ width: remCss(100) }}
        label={LANG_CONST.buttons.back}
        onClick={prev}
      />
    )}
    <div className={'mc-grow'} />
    <MCButton
      medium
      light
      radius
      primary
      label={LANG_CONST.buttons.cancel}
      onClick={hide}
      style={{ width: remCss(100) }}
    />
    <MCButton
      medium
      dark
      radius
      primary
      disabled={loading}
      loading={loading}
      style={{ width: remCss(100) }}
      label={labelNext}
      onClick={next}
    />
  </div>
);

export default NavigationButtons;
